import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { blackColor, hexToRgb } from "assets/jss/style.js";
import { GridItem } from "components";
import PropTypes from "prop-types";
import React from "react";
import Icon from "@material-ui/core/Icon";

export default function CardDetalle(props) {
  const {
    titulo,
    detalle,
    image,
    icono,
    md,
    sm,
    xs
  } = props;

  return (
    <div>
      <Grid container spacing={0}>
        <Grid item md={1}></Grid>
      </Grid>
      <GridItem xs={xs} sm={sm} md={md}>
        <MuiThemeProvider theme={createTheme(theme)}>
          <div className="App">
            <Card className={"MuiEngagementCard--01"}>
              {icono ? (
                  <Icon style={{ fontSize: 25, color: "#66bb6a", marginBottom: 8 }}>
                    {icono}
                  </Icon>
              ) : (
                  <Icon style={{ fontSize: 25, color: "#66bb6a", marginBottom: 8 }}>
                    dashboard
                  </Icon>
              )}
              <CardContent>
                <Typography
                  className={"MuiTypography--heading"}
                  gutterBottom
                >
                  {titulo}
                </Typography>
                <Divider light />
                <Typography
                  className={"MuiTypography--subheading"}
                >
                  {detalle}
                </Typography>
              </CardContent>
            </Card>
          </div>
        </MuiThemeProvider>
      </GridItem>
    </div>
  );
}

CardDetalle.propTypes = {
  href: PropTypes.string,
  detalle: PropTypes.string,
  update: PropTypes.string,
  titulo: PropTypes.string,
  children: PropTypes.node,
  image: PropTypes.string,
  md: PropTypes.number,
  sm: PropTypes.number,
  xs: PropTypes.number
};


const muiBaseTheme = createTheme();
const theme = {
  overrides: {
    MuiCard: {
      root: {
        "&.MuiEngagementCard--01": {
          width: "170px",
          height: "100px",
          padding: "0.9rem",
          background: "#e6e6e657",
          position: "relative",
          display: "flex",
          margin: "40%",
          alignItems: "flex-end",
          transition: "0.4s ease-out",
          borderRadius: "10%",
          boxShadow:
            "0 16px 10px -12px rgba(" +
            hexToRgb(blackColor) +
            ", 0.56), 0 4px 25px 0px rgba(" +
            hexToRgb(blackColor) +
            ", 0.12), 0 8px 10px -5px rgba(" +
            hexToRgb(blackColor) +
            ", 0.2)",
          "&:hover": {
            transform: "translateY(15px)"
          },
          "&:before": {
            opacity: 1,
            "&.info": {
              opacity: 1,
              transform: "translateY(0px)"
            }
          },
          "& .MuiCardMedia-root": {
            paddingTop: "5.25%",
            paddingLeft: "0px",
            backgroundSize: "contain",
            marginTop: "40px",
            width: "60px",
            height: "auto",
            textAlign: "center"
          },
          "& .MuiCardContent-root": {
            textAlign: "center",
            padding: "5px"
          },
          "& .MuiDivider-root": {
            margin: `${muiBaseTheme.spacing(1)}px 0`
          },
          "& .MuiTypography--heading": {
            fontWeight: "bold",
            fontSize: "15px",
            lineHeight: "18px"
          },
          "& .MuiTypography--subheading": {
            lineHeight: 1.4,
            fontSize: "0.6rem"
          },
          "& .MuiAvatar-root": {
            display: "inline-block",
            border: "2px solid white",
            "&:not(:first-of-type)": {
              marginLeft: -muiBaseTheme.spacing()
            }
          }
        }
      }
    }
  }
};
